import axios from "axios";

export default async function putUser(user) {
    try {
        const res = await axios.put(
            `${process.env.REACT_APP_BACKEND_URL}/api/admin/user`,
            user, // corps de la requête
            {
                withCredentials: true,
                validateStatus: () => true,
            }
        );

        return {
            ok: res.status >= 200 && res.status < 300,
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        console.error("Erreur putUser:", err);
        return { ok: false, status: 0, error: err.message };
    }
}
